/* eslint-disable */

(function() {
  "use strict";

  $(".txtPolyHeight, .txtPolyLength, .txtHoop").blur(function() {
    var num = parseFloat($(this).val());
    var cleanNum = num.toFixed(2);

    if (!isNaN(cleanNum)) {
      $(this).val(cleanNum);
      if (num / cleanNum < 1) {
        var inputString = $(this).val();
        var shortenedString = inputString.substr(0, inputString.length - 1);
        $(this).val(shortenedString);
      }
    } else {
      $(this).val("");
    }
  });
})();
